import { PHOTO_UPLOAD_FIELD, PhotoSubjectType } from '@common/interfaces/photo'
import Base from './base'

/**
 * Profile photos for every subject that has one. One endpoint family replaces the four
 * subject-specific upload paths (`clients/:id` with `files[profilePicture]`,
 * `entity-info/:id` with `files[]`, `newsfeed/brand/:id` with `files[brandLogo]`,
 * `users` with `files[]` + `isAvatarDelete`).
 */
export default class Photo extends Base {
  /**
   * Separate from the subject's own `show` because an uploaded photo is a base64 data URI: it's
   * fetched once per subject and cached client-side rather than ridden along in every payload
   * that renders them. See Common/ProfilePhoto.
   */
  show(subjectType: PhotoSubjectType, id: string) {
    return this.apiClient.get(`photos/${subjectType}/${id}`)
  }

  update(subjectType: PhotoSubjectType, id: string, file: File) {
    const formData = new FormData()
    // One canonical field name for every subject — the per-subject names are gone.
    formData.append(PHOTO_UPLOAD_FIELD, file, file.name)
    return this.apiClient.put(`photos/${subjectType}/${id}`, formData)
  }

  delete(subjectType: PhotoSubjectType, id: string) {
    return this.apiClient.delete(`photos/${subjectType}/${id}`)
  }
}
